<template>
  <div class="onboarding-toggleable-block">
    <div
      v-if="showOnboarding"
      class="onboarding-toggleable-block__brief panel"
      :class="color !== '' ? `panel--${color}` : 'panel--info'"
    >
      <div class="panel__column">
        <div class="panel__group">
          <div
            class="panel__icon panel__icon--ph_lightbulb-fill_blue"
          />
          <div class="panel__content panel-content">
            <h4><slot name="title" /></h4>
            <p><slot name="subtitle" /></p>
            <div
              class="onboarding-toggleable-block__brief-cta-wrapper cta-wrapper"
            >
              <p class="cta-wrapper__text">
                <slot name="body" />
              </p>
              <div class="cta-wrapper__cta">
                <button
                  class="btn btn--secondary btn--small btn--inverted"
                  :class="{ 'loading-btn': loadingOnboarding }"
                  :disabled="loadingOnboarding"
                  @click="toggleOnboarding(false)"
                >
                  <span>
                    {{ trans('user.onboarding.cta_gotit') }}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          class="btn btn--secondary btn--small onboarding-btn--mobile"
          :class="{ 'loading-btn': loadingOnboarding }"
          :disabled="loadingOnboarding"
          @click="toggleOnboarding(false)"
        >
          <span>
            {{ trans('user.onboarding.cta_gotit') }}
          </span>
        </button>
      </div>
    </div>
    <div v-else class="onboarding-toggleable-block__help">
      <p @click="toggleOnboarding(true)">
        <span class="icon-help" />
        <span>{{ trans('user.onboarding.help') }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { flashBagError } from '@tools/flashbag';
import translation from '@elements/translation';
import Logger from '@tools/logger/logger';
import requests from '@tools/requests-mixin';

/**
 * This component display onboarding and handles toggle effect
 */
export default {
  name: 'OnboardingToggleableBlock',
  mixins: [ translation, requests ],
  props: {
    urlHideOnboarding: { type: String, required: true },
    userSetting: { type: Object, default: () => {}, required: true },
    color: { type: String, default: '', required: false },
  },
  data() {
    return {
      showOnboarding: false,
      loadingOnboarding: false,
      initialUserSettingsValue: null,
    };
  },
  mounted() {
    this.showOnboarding = this.userSetting.value === '0';
    this.initialUserSettingsValue = this.userSetting.value;
  },
  methods: {
    toggleOnboarding(show) {
      if (!show && this.initialUserSettingsValue === '0') {
        this.loadingOnboarding = true;
        this.post(this.urlHideOnboarding)
          .then(() => {
            this.initialUserSettingsValue = '1';
            this.showOnboarding = show;
          })
          .catch((err) => {
            flashBagError();
            Logger.error('Error catched', err);
          })
          .finally(() => {
            this.loadingOnboarding = false;
          });

        return;
      }

      this.showOnboarding = show;
    },
  },
};
</script>
